import { computed, makeObservable, observable, toJS } from 'mobx'
import type {
  ICallingActionPayload,
  ICallingActionResponse,
  IDuringCallActionSettings,
} from 'entities/AICalling/api/types'
import { BaseCallingAction } from './BaseCallingAction'

export class DuringCallAction extends BaseCallingAction {
  actionName: string
  description: string
  voiceResponse: string | undefined

  constructor(item: ICallingActionResponse | ICallingActionPayload) {
    super(item)
    this.actionName = 'name' in item.settings ? item.settings.name : ''
    this.description =
      'trigger_description' in item.settings ? item.settings.trigger_description : ''
    this.voiceResponse =
      'voice_response' in item.settings ? item.settings.voice_response : undefined

    makeObservable(this, {
      actionName: observable,
      description: observable,
      voiceResponse: observable,
      message: observable,
      media_url: observable,
      settings: computed,
    })
  }

  get settings(): IDuringCallActionSettings {
    return {
      message: this.message,
      media_url: this.media_url,
      name: this.actionName,
      trigger_description: this.description,
      voice_response: this.voiceResponse,
    }
  }

  get payload() {
    const base = {
      action_type: this.actionType,
      trigger_type: this.triggerType,
      settings: this.settings,
    }
    if (this.serverId) {
      return toJS({ ...base, id: this.serverId })
    }
    return toJS(base)
  }
}
